<template>
  <div >
        <Signup class="marginal"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Signup from '@/components/Signup.vue';
export default {
  name: 'SignupPage',
  components: {
    Signup,
    
  }
}
</script>